import React, { Component } from 'react';
import './nav.scss';
import { NavLink } from 'react-router-dom';
import { Transition } from 'react-spring/renderprops';

export default class Nav extends Component<{}, { show: boolean }> {
    state: { show: boolean };

    constructor(props: {}) {
        super(props);
        this.state = { show: false };
    }

    toggleShow = () => {
        this.setState({ show: !this.state.show });
    };

    hide = (e: any) => {
        if (e && e.relatedTarget) {
            e.relatedTarget.click();
        }
        this.setState({ show: false });
    };
    render() {
        return (
            <div>
                <header>
                    <div className='company-logo'>
                        <h4>
                            <NavLink to='/' className='company-logo__link'>
                                <span className='company-logo__decade'>Decade </span>
                                <span className='company-logo__trucking'> Trucking</span>
                            </NavLink>
                            <hr className='logo-line' />
                        </h4>
                    </div>
                    <input
                        type='checkbox'
                        id='toggle'
                        onChange={this.toggleShow}
                        checked={this.state.show}
                        style={{ display: 'none' }}
                    />
                    <label className='toggle-btn toggle-btn__cross' htmlFor='toggle'>
                        <div className='bar' />
                        <div className='bar' />
                        <div className='bar' />
                    </label>
                    {this.state.show && (
                        <Transition
                            items={this.state.show}
                            from={{ transform: 'translate3d(0,100px,0)', opacity: 0 }}
                            enter={{ transform: 'translate3d(0,0px,0)', opacity: 1 }}
                            trail={100}
                        >
                            {() => props => (
                                <nav>
                                    <ul>
                                        <li style={props}>
                                            <NavLink to='/' onClick={this.hide}>
                                                Home
                                            </NavLink>
                                        </li>
                                        <li style={props}>
                                            <NavLink to='/about' onClick={this.hide}>
                                                About
                                            </NavLink>
                                        </li>
                                        <li style={props}>
                                            <NavLink to='/services' onClick={this.hide}>
                                                Services
                                            </NavLink>
                                        </li>
                                        <li style={props}>
                                            <NavLink to='/contact' onClick={this.hide}>
                                                Contact
                                            </NavLink>
                                        </li>
                                    </ul>
                                </nav>
                            )}
                        </Transition>
                    )}
                </header>
            </div>
        );
    }
}
